import React, { createContext, useState } from "react";

export const useDB = (initialSelections) => {
  const [values, setValues] = useState(initialSelections);
  return [
    values,
    (data) => {
      setValues((values) => ({
        ...values,
        ...data,
      }));
    },
  ];
};
